import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";
import cx from "classnames";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import PasswordResetModal from "components/PasswordResetModal";
import Sidebar from "components/Sidebar/Sidebar.js";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import routes from "routes.js";
import { loadAuthorizedApplication, resetApp } from "store/actions/applicationActions";
import { useAuth } from "util/auth.js";
import { useRouter, useLocation } from "util/router.js";
import UserInformationPage from 'pages/userInformation'
import Intercom from 'react-intercom';
import { Helmet } from "react-helmet";
import { Elements } from '@stripe/react-stripe-js';
import { StripeProvider } from 'react-stripe-elements';
import { apiRequest } from 'util/api/util'
import { Modal } from "react-bootstrap";
import Iframe from 'react-iframe'
import ForumIcon from '@material-ui/icons/Forum';

var ps;

const useStyles = makeStyles(styles);

const CircleWidget = (props) => {

  const auth = useAuth();
  const intercom_user = {
    user_id: auth?.userData?.id,
    email: auth?.userData?.email,
    name: auth?.userData?.firstName,
    isInstructor: auth?.userData?.isInstructor ?? false,
    schedule: `https://sutrapro.com/${auth?.userData?.widgetName}`
  }

  const [show, setShow] = React.useState(false)

  return (
    <>
      {!show && (
        <Intercom appID="t5q6yemg" {...intercom_user} />
      )}
      <Modal
        className="modal-circle"
        centered
        size="xl"
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Iframe
            styles={{height: "100vh"}}
            frameBorder="0"
            width="100%"
            url={"https://community.sutrapro.com/?iframe=true"}
            allowFullScreen={true}
            className="embed-circle"
          />
        </Modal.Body>

      </Modal>
      <div style={{
        zIndex: "1100",
        position: "absolute",
        width: "100px",
        height: "100px",
        backgroundColor: "transparent",
        right: "0px",
        bottom: "0px",
        marginRight: "100px",
      }}>
        <div
          onClick={() => setShow(true)}
          style={{
            width: "60px",
            height: "60px",
            margin: "auto",
            marginTop: "20px",
            backgroundColor: "#EA3756",
            borderRadius: "50%",
            boxShadow: "0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%)",
          }}>
            <ForumIcon
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50% , -50%)",
              color: "white"
            }}
             />
          </div>
      </div>
    </>
  )
}

export default function DashboardPage(props) {
  const auth = useAuth();
  const router = useRouter();
  const dispatch = useDispatch();

  // Redirect to /signin
  // if not signed in.
  useEffect(() => {
    if (auth.user === false) {
      dispatch(resetApp())
      router.replace('/')
    } else if (auth.user && !auth.user.isAnonymous) { //&& user?.authID !== auth.user.uid
      console.log("Loaded authorized user")
      dispatch(loadAuthorizedApplication(auth.user))
    }
  }, [auth.user]);

  useEffect(() => {
    if (auth.userData && auth.userData.firstName && !auth.userData.isInstructor) {
      // dispatch(resetApp())
      router.replace('/not-found')
    }

  }, [auth.userData])

  const instructorData = useSelector(state => state.instructor.instructor)
  const showPasswordReset = () => {
    if (instructorData && instructorData.requiresPasswordReset) {
      console.log("YES")
      return true;
    }
    console.log(instructorData)
    return false;
  }

  if (instructorData) {
    console.log("dashboard instructor data")
    console.log(instructorData)
  }

  const { ...rest } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniActive, setMiniActive] = React.useState(false);
  const [color, setColor] = React.useState("blue");
  const [bgColor, setBgColor] = React.useState("white");
  const [logo, setLogo] = React.useState(require("assets/img/logo-white.svg"));
  const classes = useStyles();
  const mainPanelClasses = classes.mainPanel;
  const mainPanel = React.createRef();
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1 && ps) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getActiveRoute = routes => {
    let activeRoute = "Home";
    console.log(routes)
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/dashboard") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  let viewModel = {
    sidebarName: instructorData.instructorProfile?.pageName ? instructorData.instructorProfile.pageName : (instructorData.firstName ? (instructorData.firstName + " " + instructorData.lastName) : "-------"),
    sidebarIcon: instructorData.instructorProfile?.partnerImageUrl ? instructorData.instructorProfile.partnerImageUrl : (instructorData.profileImageUrl ? instructorData.profileImageUrl : "")
  }

  const [] = React.useState(true);

  const stripeAccountId = auth?.stripePartner?.account_id
  // const stripeAccountId = useSelector(state => state.widget.stripeAccount)
  const [stripe, setStripe] = React.useState(null)
  useEffect(() => {
    if (window.Stripe) {
      if (stripeAccountId) {
        setStripe(window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {
          stripeAccount: stripeAccountId
        }))
      } else {
        // setStripe(window.Stripe(config.STRIPE_PUBLIC_KEY))
        // DO NOTHING
      }

    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        // Create Stripe instance once Stripe.js loads
        if (stripeAccountId) {
          setStripe(window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {
            stripeAccount: stripeAccountId
          }))
        } else {
          // setStripe(window.Stripe(config.STRIPE_PUBLIC_KEY))
          // DO NOTHING
        }
      });
    }
  }, [stripeAccountId])


  const [blockDashboard, setBlockDashboard] = React.useState(false)
  const user = useSelector(state => state.user.userData)
  useEffect(() => {

    if (!user.platformID) {
      return
    }
    console.log("fetching data")

    apiRequest('app/dashboardAccess?partnerId=' + user.platformID)
      .then(response => {
        setBlockDashboard(false)
      })
      .catch(err => {
        setBlockDashboard(true)
      })

  }, [user])

  return (
    <>

      <Helmet>
        <title>Dashboard</title>
        <meta name="description" content="Sutra Pro Application" />
      </Helmet>
      <CircleWidget />
      
      <AdminNavbar
        sidebarMinimize={sidebarMinimize.bind(this)}
        miniActive={miniActive}
        brandText={getActiveRoute(routes)}
        handleDrawerToggle={handleDrawerToggle}
        {...rest}
      />
      {blockDashboard ? <>
        <h4 style={{ textAlign: "center", marginTop: "200px" }}>Please contact support</h4>
      </> : (
        <div className={classes.wrapper}>
          
          <Sidebar
            routes={routes}
            logoText={"Sutra"}
            logo={logo}
            name={viewModel.sidebarName}
            icon={viewModel.sidebarIcon}
            handleDrawerToggle={handleDrawerToggle}
            open={mobileOpen}
            color={color}
            bgColor={bgColor}
            miniActive={miniActive}
            {...rest}
          />
          <div className={mainPanelClasses} ref={mainPanel}>
            <div className={classes.content}>

              <StripeProvider stripe={stripe} >
                <Elements stripe={stripe} >
                  <Switch>
                    {getRoutes(routes)}
                    <Route
                      path="/dashboard/user-settings"
                      component={UserInformationPage}
                    />
                    <Redirect from="/dashboard" to="/dashboard/home" />
                  </Switch>
                </Elements>
              </StripeProvider>
            </div>
          </div>
          <PasswordResetModal
            show={showPasswordReset()}
          />
        </div>

      )}
    </>
  );
}